import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function CreateFirmware({ handleClose, refreshList }) {
  const [path, setPath] = useState('');
  const uploadFile = useRef();
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [{ isLoading, isError, data }, postData] = useApi();
  // const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('path', path);
    postData('/firmware', 'POST', formData, 'multipart/form-data');
  };
  const handleFiles = () => {
    (async () => {
      const text = await uploadFile.current.files[0];
      setFileName(uploadFile.current.files[0].name);
      setSelectedFile(text);
    })();
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      refreshList();
      handleClose();
    }
  }, [isLoading, isError, data]);
  const onClick = () => {
    uploadFile.current.click();
  };

  // const uploadFirmware = async () => {
  //   const body = {
  //     path,
  //     file: selectedFile,
  //   };
  //   postData('/firmware', 'POST', body);
  // };
  return (
    <div
      className="flex justify-center items-center h-full w-full z-50 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className="bg-white w-full md:w-1/3 h-auto px-5 pt-4 relative rounded-2xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4 pb-1">Upload Firmware</p>
        <form onSubmit={handleSubmit}>
          {fileName ? (
            <div className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm" style={{ width: '92%', left: '4%', color: '#9B9B9B' }}>
              <div>{fileName}</div>
              <img
                src="assets/img/Close.svg"
                className="w-3 ml-3 absolute right-6 top-5"
                
                alt=""
                onClick={() => {
                  setSelectedFile(null);
                  setFileName('');
                }}
              />
            </div>
          ) : (
            <div
              className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
              style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
              onClick={onClick}
            >
              <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
              <input ref={uploadFile} className="hidden" onChange={handleFiles} type="file" id="input" />
              Choose the file
            </div>
          )}
          <input
            type="text"
            className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
            style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
            placeholder="Path"
            value={path}
            onChange={(e) => setPath(e.target.value)}
          />
          <button
            type="submit"
            className="rounded-3xl block m-auto my-4 focus:outline-none w-1/2 h-10 text-white bg-btnBg cursor-pointer "
            style={{ border: '1px solid #16406D' }}
          >
            {/* <img src="assets/img/Upload.svg" className="w-6 mr-3" alt="" /> */}
            Upload
          </button>
          {/* <button type="submit">Upload</button> */}
        </form>
        {/* <div
          className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
          style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
          onClick={onClick}
        >
          <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
          <input ref={uploadFile} className="hidden" onChange={handleFiles} type="file" id="input" />
          Choose the file
        </div>
        <input
          type="text"
          className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
          style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
          placeholder="Path"
          value={path}
          onChange={(e) => setPath(e.target.value)}
        /> */}
        {/* </form> */}
      </div>
    </div>
  );
}

export default CreateFirmware;
